<app-header [forceLightBackground]="true"></app-header>
<div class="user-activities-home">
  <div class="user-activities-home--layout">
    <div class="user-activities-home--sidebar">
      <app-admin-sidebar></app-admin-sidebar>
    </div>
    <div class="user-activities-home--content">
      <app-page-header></app-page-header>
      
      <div class="user-activities-container">
        <div class="tab-content-wrapper">
          <app-admin-user-activities #assetActivities></app-admin-user-activities>
        </div>
      </div>
    </div>
  </div>
</div>
